import React from 'react'
import Layout from '../components/layout'
import Images from '../examples/Images'

const images = () => {
    return (
        <Layout>
            <Images></Images>
        </Layout>
    )
}

export default images
